import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import App from '../main/App';

const Router = () => (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

export default Router;
